import React, { useEffect, useState } from 'react'
import CommonPopupForm from '../others/CommonPopupForm';
import { createMedicalCategory, fetchMedicalDepartments, fetchMedicalCategories, editMedicalCategory, deleteMedicalCategory, updateSeo, createSeo, getSeoByref } from '../../../services';
import { toast } from 'react-toastify';
import CommonDelete from '../../../components/CommonDelete';
import { useNavigate } from 'react-router-dom';
import { formatSlug } from '../../../utils/Slug';
function Category() {
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false);
    const [formData, setFormData] = useState({
        name: "",
        alias: "",
        description: "",
        med_department: "",
    });
    const [medicalDepartments, setMedicalDepartments] = useState([]);
    const [editingId, setEditingId] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [isSelectOpen, setIsSelectOpen] = useState(false);
    const [search, setSearch] = useState("");
    const [medicalCategories, setMedicalCategories] = useState([]);
    const [showConfirm, setShowConfirm] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const filteredOptions = medicalDepartments.filter((item) =>
        item.name.toLowerCase().includes(search.toLowerCase())
    );

    const [refId, setRefId] = useState(null);
    const [metaData, setMetaData] = useState({
        uid: '',
        title: '',
        description: '',
        reference_id: refId,
        keywords: '',
        type: 'category'
    });
    const [isMetaOpen, setIsMetaOpen] = useState(false);

    //seo functions 

    const metaHandleChange = (e) => {
        const { name, value } = e.target;
        setMetaData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmitMeta = async () => {
        try {
            const payload = {
                uid: metaData.uid || '',
                title: metaData.title || '',
                description: metaData.description || '',
                reference_id: metaData.reference_id || refId,
                keywords: metaData.keywords || '',
                type: metaData.type || 'category'
            }
            const res = await createSeo(payload);
            if (res) {

                setMetaData({
                    uid: '',
                    title: '',
                    description: '',
                    keywords: '',
                    reference_id: refId

                }); // save returned object (with id)
                toast.success("Metadata created successfully");

            }
        } catch (error) {
            console.log(error);
        }
    };

    const handleUpdateMeta = async () => {
        try {
            if (!metaData.uid) return; // must have id for update
            const payload = {
                uid: metaData.uid || '',
                title: metaData.title || '',
                description: metaData.description || '',
                reference_id: metaData.reference_id || refId,
                keywords: metaData.keywords || '',
                type: metaData.type || 'category'
            }
            const res = await updateSeo(payload.uid, payload);
            if (res) {
                setMetaData(
                    {
                        uid: res?.uid,
                        title: res.title,
                        description: res.description,
                        keywords: res.keywords,
                    }
                );
                toast.success("Metadata updated successfully");
            }
        } catch (error) {
            console.log(error);
        }
    };

    const fetchSeo = async (id) => {
        try {
            const res = await getSeoByref(id);

            // console.log(res)
            if (res && res.length > 0) {
                setMetaData({
                    uid: res[0].uid,
                    title: res[0].title,
                    description: res[0].description,
                    reference_id: res[0]?.reference_id,
                    keywords: res[0].keywords,
                    type: res[0].type,
                });
            }

        } catch (error) {
            console.error(error);
        }
    }

    //   =====================


    // console.log("medical", medicalDepartments);
    const getMedicalDepartments = async () => {
        try {
            const res = await fetchMedicalDepartments();
            // console.log("dfddf", res?.data?.data)
            setMedicalDepartments(res?.data?.data)
        } catch (error) {
            console.error(error);
        }
    };
    const getMedicalCategories = async () => {
        try {
            const res = await fetchMedicalCategories();
            // console.log("dfddf", res?.data?.data)
            setMedicalCategories(res?.data?.data)
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        getMedicalCategories();
        getMedicalDepartments();
    }, [])
    const handleChange = (e) => {
        const { value, name } = e.target;
        setFormData({ ...formData, [name]: value });
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const payload = {
                ...formData,
                alias: formatSlug(formData.alias),
            };
            let response;
            if (editingId) {
                response = await editMedicalCategory(editingId, payload);
            } else {
                response = await createMedicalCategory(payload);
            }

            if (response) {
                getMedicalCategories();
                setIsOpen(false);

                setFormData({
                    name: "",
                    alias: "",
                    description: "",
                    med_department: "",
                });
                setSearch("");
                setEditingId(null);

            }
        } catch (error) {
            console.error(error);
            toast.error(error.response.data.message.alias[0] || "An error occurred while saving the department.");
        }
    };

    // console.log("dk", refId);
    const handleEdit = (item) => {
        // console.log(item.id)
        setEditingId(item.id); // store the ID for editing
        const medDepartmentId = item.med_department_detail?.id || item.med_department?.id || "";
        const medDepartmentName = item.med_department_detail?.name || "";
        setFormData({

            name: item.name || "",
            description: item.description || "",
            alias: item.alias || "",
            med_department: medDepartmentId,

        });
        // 👇 Add this line to show selected department in input
        setSearch(medDepartmentName);
        setIsOpen(true);
    };

    const handleDelete = (id) => {
        setSelectedId(id);
        setShowConfirm(true);
    };
    const confirmDelete = async () => {
        try {
            const res = await deleteMedicalCategory(selectedId);
            if (res) {
                toast.success("Medical category deleted successfully!");
                setShowConfirm(false);
                getMedicalCategories();
            }
        } catch (error) {
            console.error(error)
        }
    };
    const filteredDepartments = medicalCategories.filter((item) =>
        item.name.toLowerCase().includes(searchQuery.toLowerCase())

    );

    // console.log("dd",filteredDepartments)
    return (
        <div>
            <div className='flex items-center justify-between my-6'>
                <h1 className='font-bold text-3xl'>Department Categories</h1>
                <div className="space-y-2">
                    <input
                        type="text"
                        name="search"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        placeholder="Search by name"
                        className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-[#019c89]"
                    />

                </div>
                <button
                    className="bg-[#019c89] text-white px-4 py-2 rounded"
                    onClick={() => setIsOpen(true)}
                >
                    Add Data
                </button>
            </div>

            <div className='py-5 mt-4 overflow-x-auto'>
                {
                    filteredDepartments.length > 0 ? (
                        <div className="inline-block min-w-full align-middle">
                            <table className="min-w-full divide-y divide-gray-200">
                                <thead className="bg-gray-50">
                                    <tr>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Medical Department</th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider break-words">Description</th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Meta Deta</th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Extra Descriptions</th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-gray-200">
                                    {filteredDepartments.map((item) => (
                                        <tr key={item.uid}>
                                            <td className="px-6 py-4 whitespace-nowrap">{item.name}</td>
                                            <td className="px-6 py-4 whitespace-nowrap">{item.med_department_detail.name}</td>
                                            <td className="px-6 py-4">{item.description}</td>
                                            <td className="px-6 py-4 whitespace-nowrap cursor-pointer"
                                                onClick={() => {
                                                    fetchSeo(item.id)
                                                    setRefId(item.id)
                                                    setIsMetaOpen(true)
                                                }}
                                            >Add/Update</td>
                                            <td className="px-6 py-4 whitespace-nowrap cursor-pointer"

                                                onClick={() => navigate("/admin/product-description/", {
                                                    state: {
                                                        data: item,
                                                        type: "category"
                                                    }
                                                })}

                                            >Add/Update</td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <button
                                                    onClick={() => handleEdit(item)}
                                                    className="text-blue-600 hover:text-blue-900 mr-2"
                                                >
                                                    Edit
                                                </button>
                                                {/* <button
                                                    onClick={() => handleDelete(item.id)}
                                                    className="text-red-600 hover:text-red-900"
                                                >
                                                    Delete
                                                </button> */}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <p>No categories found matching your search.</p>
                    )
                }
            </div>



            <CommonPopupForm
                title={editingId ? "Update Category" : "Add Category"}
                isOpen={isOpen}
                // onClose={() => setIsOpen(false)}
                onClose={() => {
                    setIsOpen(false);
                    setEditingId(null);

                    setFormData({
                        name: "",
                        alias: "",
                        description: "",
                        med_department: "",
                    });
                    setSearch("");
                }}
                onSubmit={handleSubmit}
            >
                {/* Scrollable content container */}
                <div className="space-y-6 overflow-y-auto max-h-[65vh] px-4 py-2">



                    {/* Grid Inputs */}
                    <div className="grid lg:grid-cols-2 gap-6">
                        <div className="space-y-2">
                            <label className="block text-sm font-medium text-gray-700">Name</label>
                            <input
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                placeholder="Name"
                                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-[#019c89]"
                            />
                        </div>

                        <div className="space-y-2">
                            <label className="block text-sm font-medium text-gray-700">Slug (Unique)</label>
                            <input
                                type="text"
                                name="alias"
                                value={formData.alias}
                                onChange={handleChange}
                                placeholder="Alias"
                                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-[#019c89]"
                            />
                        </div>
                        <div className="space-y-2 relative">
                            <label className="block text-sm font-medium text-gray-700">Medical Department</label>
                            <input
                                type="text"
                                value={search}
                                onChange={(e) => {
                                    setSearch(e.target.value);
                                    setIsSelectOpen(true);
                                }}
                                onFocus={() => setIsSelectOpen(true)}
                                placeholder="Search medical department"
                                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-[#019c89]"
                            />
                            {isSelectOpen && (
                                <ul className="absolute z-10 mt-1 w-full bg-white border rounded shadow max-h-60 overflow-auto">
                                    {filteredOptions.length > 0 ? (
                                        filteredOptions.map((item) => (

                                            <li
                                                key={item.id}

                                                onClick={() => {
                                                    setSearch(item.name);
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        med_department: item.id                 // Set actual UID to send
                                                    }));
                                                    setIsSelectOpen(false);
                                                    // update stock_no or any other field
                                                }}
                                                className="px-4 py-2 cursor-pointer hover:bg-[#019c89] hover:text-white text-sm"
                                            >
                                                {item.name}
                                            </li>
                                        ))
                                    ) : (
                                        <li className="px-4 py-2 text-gray-500 text-sm">No results found</li>
                                    )}
                                </ul>
                            )}
                        </div>
                    </div>
                    <div className="space-y-2">
                        <label className="block text-sm font-medium text-gray-700">Description</label>
                        <textarea
                            name="description"
                            value={formData.description}
                            onChange={handleChange}
                            placeholder="Description"
                            className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-[#019c89]"
                        />
                    </div>
                </div>
            </CommonPopupForm>


            <CommonDelete
                isOpen={showConfirm}
                message="Are you sure you want to delete this speciality?"
                onConfirm={confirmDelete}
                onCancel={() => setShowConfirm(false)}
            />


            {/* meta  data*/}
            {isMetaOpen && (
                <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50">
                    <div className="bg-white rounded-xl shadow-lg w-full max-w-5xl p-6 relative">
                        {/* Header */}
                        <div className="flex justify-between items-center mb-4">
                            <h2 className="text-lg font-semibold">
                                {metaData.uid ? "Update Meta Data" : "Add Meta Data"}
                            </h2>
                            <button
                                onClick={() => {
                                    setIsMetaOpen(false)
                                    setMetaData({
                                        uid: '',
                                        title: '',
                                        description: '',
                                        reference_id: null,
                                        keywords: '',
                                        type: 'category'
                                    });
                                }}
                                className="text-gray-500 hover:text-gray-800"
                            >
                                ✕
                            </button>
                        </div>

                        {/* Form */}
                        <div className="space-y-4">
                            <div>
                                <label className="block text-sm font-medium text-gray-700">
                                    Title
                                </label>
                                <input
                                    type="text"
                                    name="title"
                                    value={metaData.title}
                                    onChange={metaHandleChange}
                                    className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-[#019c89]"
                                />
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700">
                                    Keywords
                                </label>
                                <input
                                    type="text"
                                    name="keywords"
                                    value={metaData.keywords}
                                    onChange={metaHandleChange}
                                    className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-[#019c89]"
                                />
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700">
                                    Description
                                </label>
                                <textarea
                                    name="description"
                                    value={metaData.description}
                                    onChange={metaHandleChange}
                                    className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-[#019c89]"
                                />
                            </div>
                        </div>

                        {/* Footer Buttons */}
                        <div className="flex justify-end gap-3 mt-6">
                            <button
                                onClick={() => {
                                    setIsMetaOpen(false)
                                    setMetaData({
                                        uid: '',
                                        title: '',
                                        description: '',
                                        reference_id: null,
                                        keywords: '',
                                        type: 'department'
                                    });

                                }}
                                className="px-4 py-2 border rounded-lg text-gray-600 hover:bg-gray-100"
                            >
                                Cancel
                            </button>

                            {metaData.uid ? <button
                                onClick={() => {
                                    // console.log("Submitted:", metaData);
                                    setIsMetaOpen(false);
                                    handleUpdateMeta()
                                }}
                                className="px-4 py-2 bg-[#019c89] text-white rounded-lg hover:bg-[#017d6d]"
                            >
                                update
                            </button> :
                                <button
                                    onClick={() => {
                                        // console.log("Submitted:", metaData);
                                        setIsMetaOpen(false);
                                        handleSubmitMeta()
                                    }}
                                    className="px-4 py-2 bg-[#019c89] text-white rounded-lg hover:bg-[#017d6d]"
                                >
                                    Submit
                                </button>
                            }


                        </div>
                    </div>
                </div>
            )}

        </div>
    )
}

export default Category
